import { Flex, Text, Icon } from '@chakra-ui/react';
import React from 'react';

import { RDFV } from 'packages/dataPipeline/types/dataPipelineTypes';
import { getReportingDateVersionLabel } from 'packages/dataPipeline/ui/utils/getReportingDateVersionString';
import { FiCalendar } from 'react-icons/fi';

export const DateAndVersionInput = ({
  selectedRDFV,
  isNewVersion,
  onClick,
  children,
}: {
  selectedRDFV: RDFV | null;
  // the selected version has no run yet
  isNewVersion: boolean;
  onClick: () => void;
  children?: React.ReactNode;
}) => {
  return (
    <Flex
      width="100%"
      borderWidth="1px"
      borderRadius="5px"
      padding="6px 16px"
      minHeight="40px"
      alignItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      <Icon as={FiCalendar} marginRight="10px" h="inherit" />
      {selectedRDFV ? (
        <Text>
          {`${getReportingDateVersionLabel(
            selectedRDFV.reportingDate,
            selectedRDFV.fileVersion,
          )}${isNewVersion ? ' (new)' : ''}`}
        </Text>
      ) : (
        <Text>Select Date</Text>
      )}
      {children}
    </Flex>
  );
};
